import HeaderPresentation2 from "../../OutsiderDesignAssets/components/headers/HeaderPresentation2";

export default function Landing({ pub }) {
  return <HeaderPresentation2 pub={pub} />;
}
